let slides = document.querySelectorAll('.show-neighbors-carousel .carousel-item');
let equalHeightsDiv = document.querySelector('.show-neighbors-carousel .equalHeights');

// var myCarousel = document.querySelector('#myCarousel')
// var carousel = new bootstrap.Carousel(myCarousel, {interval: false, wrap: true})

function slidersPositionList() {
    slides.forEach((el, index) => {
        // number of slides per carousel-item
        const minPerSlide = slides.length;
        let next = el.nextElementSibling;
        for (let i = 1; i < minPerSlide; i++) {

            if (!next) {
                // wrap carousel by using first child
                next = slides[0];
            }
            let cloneChild = next.cloneNode(true);
            el.appendChild(cloneChild.children[0]);
            next = next.nextElementSibling;
        }
    })

}
let variableHeight = 0;
let tallest = 0;
function slidersShowHiddenEqualHeights() {
    let len = 0
    tallest = 0;
    var elm, elmHeight;
    let styleTxt = '';
    let styleHeight = '';
    let valueStyle = '';
    slides.forEach(el => {
        let children = el.children;

        len = el.children.length
        // let tallest = 0;
        // var elm, elmHeight;
        for (let x = 0; x < len; x++) {
            children[x].classList.remove("d-none");
            elm = el.children[x].querySelectorAll('.item__third .lp-container-brick');
            elm[0].style.height = null;
            elmHeight = elm[0].offsetHeight;
            tallest = (elmHeight > tallest) ? elmHeight : tallest;
        }
        for (let x = 0; x < len; x++) {
            elm = el.children[x].querySelectorAll('.item__third .lp-container-brick');
            styleHeight = 'height:'
            styleTxt = 'px; display: flex; flex-direction: column; justify-content: space-around; ';
            if( tallest === 0 )
            {
                tallest = variableHeight;
            }
            valueStyle = styleHeight + tallest + styleTxt;
            elm[0].style.cssText += valueStyle

            // elm[0].style.height += tallest + 'px';
            // elm[0].style.cssText += 'display: flex; flex-direction: column; justify-content: space-around ';

        }
        equalHeightsDiv.style.height = (tallest + 70) + 'px';

        for (let i = 0; i < children.length; i++) {

            if (window.innerWidth >= 576) {
                if (i <= 2) {
                    children[i].classList.add("show");
                } else {
                    children[i].classList.add("d-none");
                }
            } else {
                if (i == 1) {
                    children[i].classList.add("show");
                    children[i].style.padding = '0 3rem';
                } else {
                    children[i].classList.add("d-none");
                }
            }

            if (i == 0) {
                children[i].classList.add("item-slider-lp-prev");
            }
            if (i == 1) {
                children[i].classList.add("item-slider-lp-center");
            }
            if (i == 2) {
                children[i].classList.add("item-slider-lp-next");
            }
        }
    });
    if(tallest !== 0){
        variableHeight = tallest;
    }
}

let btnPrev = document.querySelector("#carouselBtnPrevious");
if (document.body.contains(btnPrev)) {
//document.querySelector("#carouselBtnPrevious").addEventListener("click", FunctionPrevious);
    document.querySelector("#carouselBtnPrevious").addEventListener("click", FunctionPrevious);
}
let btnNext = document.querySelector("#carouselBtnNext")
if (document.body.contains(btnNext)) {
    btnNext.addEventListener("click", FunctionNext);
}

function FunctionPrevious() {
    let clickPrevious = document.querySelector('#carousel-list-slide');
    clickPrevious.classList.add("mystylePrevious");
    clickPrevious.classList.remove("mystyleNext");
}

function FunctionNext() {
    let clickNext = document.querySelector('#carousel-list-slide');
    clickNext.classList.add("mystyleNext");
    clickNext.classList.remove("mystylePrevious");
}

window.addEventListener('DOMContentLoaded', slidersPositionList)
window.addEventListener('DOMContentLoaded', slidersShowHiddenEqualHeights)
window.addEventListener('resize', slidersShowHiddenEqualHeights)